import { render, staticRenderFns } from "./servers.vue?vue&type=template&id=0281949c&scoped=true&"
import script from "./servers.vue?vue&type=script&lang=js&"
export * from "./servers.vue?vue&type=script&lang=js&"
import style0 from "./servers.vue?vue&type=style&index=0&id=0281949c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0281949c",
  null
  
)

export default component.exports